import { useEffect, useState } from "react";
import { getListSearchingPb } from "../api";

export const useListSearchingPb = (params) => {
  const [data, setData] = useState([]);
  async function fetchData() {
    const response = await getListSearchingPb({ status: 1, ...params });
    if (response?.status) setData(response?.data.data);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};
export const useCountListSearchingPb = (params) => {
  const [data, setData] = useState([]);
  async function fetchData() {
    const response = await getListSearchingPb({ status: 1, ...params });
    if (response?.status) setData(response?.data.total);
  }
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);
  return data;
};
